import { useEffect, useState } from "react";

import { ContextMenuItem } from "@/components/ui/context-menu";

/**
 * Keeps color selection in the context menu to avoid opening extra panels.
 */
const ColorPicker: React.FC<
  React.ComponentProps<"div"> & {
    rightClickedElement: HTMLElement;
  }
> = ({ rightClickedElement }) => {
  const [color, setColor] = useState("#000000");
  const rgbStringToHex = (rgbString: string, fallback = "#000000"): string => {
    if (!rgbString) return fallback;

    const normalized = rgbString.trim().toLowerCase();

    if (normalized === "transparent") return fallback;

    if (normalized.startsWith("#")) {
      if (normalized.length === 4) {
        const r = normalized[1];
        const g = normalized[2];
        const b = normalized[3];
        return `#${r}${r}${g}${g}${b}${b}`;
      }

      if (normalized.length === 7) return normalized;
    }

    const rgbArray = normalized.match(/\d+(\.\d+)?/g);

    if (!rgbArray || rgbArray.length < 3) return fallback;

    const [r, g, b] = rgbArray.slice(0, 3).map(Number);

    const toHex = (n: number) => {
      const hex = Math.min(255, Math.max(0, n)).toString(16).padStart(2, "0");
      return hex;
    };

    return `#${toHex(r)}${toHex(g)}${toHex(b)}`;
  };

  useEffect(() => {
    const computed = getComputedStyle(rightClickedElement);
    const rawColor =
      computed.backgroundColor || rightClickedElement.style.backgroundColor;

    setColor(rgbStringToHex(rawColor, "#000000"));
  }, [rightClickedElement]);

  return (
    <>
      <ContextMenuItem className="p-0">
        <label
          className="flex w-full items-center justify-between px-2 py-1.5"
          onClick={(e) => e.stopPropagation()}
        >
          رنگ دکمه
          <span
            className="block size-5 rounded-full border border-slate-300"
            style={{ backgroundColor: color }}
          ></span>
          <input
            type="color"
            className="absolute size-0 cursor-pointer opacity-0"
            defaultValue={color}
            onChange={(e) => {
              setColor(e.target.value);
              rightClickedElement.style.backgroundColor = e.target.value;
            }}
          />
        </label>
      </ContextMenuItem>
    </>
  );
};
export default ColorPicker;
